// extracted by mini-css-extract-plugin
export default {"recos":"K4-z","productCardOverride":"L4-z","rowHasBadge":"M4-z"};